// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

::ng-deep .form-group {
  text-align: left;
}

::ng-deep input, ::ng-deep select {
  height: 38px;
  border-radius: var(--vl-border-radius);
}

ion-item {
  --padding-start: 0;
}

.saved-card {
  --background: white !important;
  margin-bottom: 16px;
  --border: none;
  margin: 0 -30px;
  margin-top: 24px;
  --padding-start: 30px;
}
.saved-card ion-avatar {
  height: 53px;
  width: 50px;
  align-items: center;
  display: flex;
}
.saved-card ion-icon, .saved-card vl-icon {
  position: absolute;
  right: 16px;
  z-index: 100;
  top: 16px;
}
.saved-card ::ng-deep vl-icon svg {
  stroke: var(--vl-black-font);
}
.saved-card.card-view {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}

.custom-btn-block ion-item {
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/app/modules/payment/components/pay-with-wrapper/components/pay-with-saved-card/pay-with-saved-card.component.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EACE,gBAAA;AA0DF;;AAvDA;EACE,YAAA;EACA,sCAAA;AA0DF;;AAvDA;EACE,kBAAA;AA0DF;;AAtDA;EACE,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAyDF;AAvDE;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AAyDJ;AAtDE;EACE,kBAAA;EACA,WDvBa;ECwBb,YAAA;EACA,SAAA;AAwDJ;AApDI;EACE,4BAAA;AAsDN;AAlDE;EACE,4BAAA;EACA,6BAAA;AAoDJ;;AA5CE;EACE,mBAAA;AA+CJ","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\n::ng-deep .form-group {\n  text-align: left;\n}\n\n::ng-deep input, ::ng-deep select {\n  height: 38px;\n  border-radius: var(--vl-border-radius);\n}\n\nion-item {\n  --padding-start: 0;\n}\n\n\n.saved-card {\n  --background: white !important;\n  margin-bottom: 16px;\n  --border: none;\n  margin: 0 -30px;\n  margin-top: 24px;\n  --padding-start: 30px;\n\n  ion-avatar {\n    height: 53px;\n    width: 50px;\n    align-items: center;\n    display: flex;\n  }\n\n  ion-icon, vl-icon {\n    position: absolute;\n    right: $global-padding;\n    z-index: 100;\n    top: 16px;\n  }\n\n  ::ng-deep vl-icon {\n    svg {\n      stroke: var(--vl-black-font);\n    }\n  }\n\n  &.card-view {\n    border-top-left-radius: 25px;\n    border-top-right-radius: 25px;\n  }\n}\n\n\n.custom-btn-block {\n  // margin-bottom: 36px !important;\n\n  ion-item {\n    margin-bottom: 16px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
